import React from 'react';
import Slider from 'react-slick';

export const SliderComponent = (props) => {
    let settings = {
        autoplay: false,
        arrows: true,
        dots: false,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 1,
        respondTo: 'min',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const windowWidth = window.innerWidth > 1200 ? 'calc(100vw - 300px)' : '100vw';

    return (
        <section className="col-12 kiwi-slider">
            <div className="slider"
                style={{ width: windowWidth }}>
                <Slider {...settings}>
                    {props.images.map((image, i) => {
                        return <img src={image} alt="Props.image" key={i} />
                    })}
                </Slider>
            </div>
        </section>
    );
};


// WEBPACK FOOTER //
// src/client/components/common/CMS/components/SliderComponent.js